import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import { env } from "./lib/env";
import "./styles/globals.css";

if (env.useCustomFonts) {
  void import("./styles/fonts.css");
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
